import React from 'react'

interface StoreWixProps {
  size?: number | string
  color?: string
  className?: string
}

const StoreWix: React.FC<StoreWixProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 256 300"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M226.36 2.138c-3.802 0-7.594-.01-11.392-.01-9.008-.02-17.32 6.87-23.677 12.333-6.19 5.32-11.493 11.768-16.556 18.17-1.816-4.982-4.203-9.876-6.68-14.345-3.247-6.373-9.615-12.518-16.744-14.003-3.61-.76-7.656-.389-11.32-.389-3.18-.01-12.205 0-12.205 0s-9.038-.01-12.212 0c-3.67 0-7.705-.37-11.32.389-7.13 1.485-13.497 7.63-16.74 14.003-2.48 4.469-4.87 9.363-6.682 14.346-5.062-6.403-10.368-12.85-16.558-18.171-6.36-5.464-14.664-12.353-23.68-12.333-3.797 0-7.595.01-11.392.01-5.426.008-10.845.015-16.275.025-3.95.018-12.7-1.022-10.63 5.409.502 1.558 2.27 2.956 3.272 4.25 1.143 1.484 2.285 2.98 3.274 4.572a221.514 221.514 0 0 1 4.59 7.708c3.557 6.278 6.555 12.901 10.087 19.211 7.773 13.92 16.087 27.52 26.133 39.94 7.42 9.16 16.38 18.41 27.467 22.956-8.37 15.556-16.706 31.135-25.048 46.703-7.227 13.465-14.449 26.859-22.066 40.108-.366.646-.747 1.28-1.09 1.929-1 1.886-2.43 4.521-2.42 6.69.008 4.302 6.39 4.43 9.447 4.45 3.294.02 6.598-.07 9.894-.103 5.73-.065 11.46-.14 17.187-.198 3.392-.038 6.839.095 10.216-.228 8.592-.827 16.45-5.123 21.52-12.16 1.643-2.289 17.05-27.557 23.284-37.765 2.355-3.865 9.742-15.416 9.742-15.416s7.377 11.551 9.737 15.416c6.23 10.208 21.64 35.476 23.282 37.766 5.075 7.036 12.926 11.332 21.52 12.159 3.38.323 6.821.19 10.213.228 5.724.058 11.456.133 17.19.198 3.296.032 6.598.123 9.897.103 3.048-.02 9.441-.148 9.446-4.45.013-2.169-1.413-4.804-2.427-6.69-.346-.649-.722-1.283-1.087-1.929-7.61-13.249-14.835-26.643-22.057-40.108-8.352-15.568-16.688-31.147-25.065-46.703 11.092-4.547 20.053-13.795 27.472-22.956 10.055-12.42 18.36-26.02 26.138-39.94 3.527-6.31 6.525-12.933 10.09-19.21a213.912 213.912 0 0 1 4.589-7.709c.984-1.593 2.13-3.088 3.269-4.571 1.012-1.295 2.768-2.693 3.277-4.251 2.064-6.43-6.674-5.391-10.624-5.409-5.434-.01-10.86-.017-16.285-.025z" />
  </svg>
)

export default StoreWix
